import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useDeliveriesRequiringAttentionHoverCardStyles = makeStyles<Theme, { link?: string }>(() => ({
  root: {
    padding: '16px',
    width: '320px',
    minHeight: '100px',
    borderRadius: '10px'
  },
  content: {
    width: '100%',
    height: '100%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px'
  },
  heading: {
    fontSize: '14px',
    margin: 0,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: '#979797'
  },
  title: {
    fontSize: '16px',
    marginBottom: '8px'
  },
  eventsList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    color: '#979797',
    '& > li': {
      fontSize: '14px',
      lineHeight: 1.5,
      fontWeight: 'normal',
      margin: 0,
      marginBottom: '2px'
    }
  },
  message: {
    fontSize: '14px',
    lineHeight: 1.5
  }
}));
